import styled from 'styled-components';

export const Base = styled.div`
	margin-left: 4px;
	padding: 4px 8px;
	font-size: 14px;
	font-family: 'Inter', sans-serif;
	color: ${({ theme }) => theme.gray[1000]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 4px;
	display: flex;
	align-items: center;
	gap: 6px;
	background: transparent;
	user-select: none;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;

export const Swatch = styled.div<{ $color: string }>`
	width: 12px;
	height: 12px;
	border-radius: 50%;
	border: 1px solid ${({ theme }) => theme.gray[200]};
	background-color: ${({ $color }) => $color};
	flex-shrink: 0;
`;
